

// Admin Imports
import MainDashboard from "./views/admin/default";
import BotVisitors from "./views/admin/BotVisitors";
import ReportView from "./views/admin/ReportView";
import Messages from "./views/admin/Messages";
import Tools from "./views/admin/Tools";
import Modeller from "./views/admin/Tools/components/DesignerViewBPMNS";
import IntegrationsConfig from "./views/admin/Tools/components/IntegrationsConfig";
import ChatInterface from "./views/admin/Tools/components/HumanChatInterface";

// Settings Components
import UserMaintenance from "./views/admin/Settings/components/UserMaintenance";
import GroupMaintenance from "./views/admin/Settings/components/GroupMaintenance";
import BillingUsage from "./views/admin/Settings/components/BillingUsage";
import GlobalConfigs from "./views/admin/Settings/components/globalConfigs";

// Frontend imports
import Home from 'views/frontend/Home';
import AboutUs from "views/frontend/About-us";
import Products from 'views/frontend/Products';
import Partners from 'views/frontend/Partners';
import Pricing from 'views/frontend/Pricing';
import Contacts from 'views/frontend/Contacts';
import Resources from "views/frontend/Resources";
import CompanyPage from "views/frontend/CompanyPage";


// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdPeople,
  MdSyncAlt,
  MdMessage,
  MdDescription,
  MdSettings,
  MdMail
} from "react-icons/md";
import { FaProjectDiagram} from "react-icons/fa";
import Admin from "layouts/admin";

const routes = [
  // Admin Routes
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: (
      <Admin>
        <MainDashboard />
      </Admin>
    ),
  },
  {
    name: "Bot Visitors",
    layout: "/admin",
    icon: <MdPeople className="h-6 w-6" />,
    path: "bot-visitors",
    component: (
      <Admin>
        <BotVisitors />
      </Admin>
    ),
  },
  {
    name: "Reports View",
    layout: "/admin",
    icon: <MdDescription className="h-6 w-6" />,
    path: "report-view",
    component: (
      <Admin>
        <ReportView />
      </Admin>
    ),
  },
  {
    name: "Messages",
    layout: "/admin",
    path: "messages",
    icon: <MdMessage className="h-6 w-6" />,
    component: (
      <Admin>
        <Messages />
      </Admin>
    ),
  },
  {
    name: "Modeller",
    layout: "/admin",
    path: "modeller",
    icon: <FaProjectDiagram className="h-6 w-6" />,
    component: (
      <Admin>
        <Modeller />
      </Admin>
    ),
  },
  {
    name: "Integrations",
    layout: "/admin",
    path: "configs",
    icon: <MdSyncAlt className="h-6 w-6" />,
    component: (
      <Admin>
        <IntegrationsConfig />
      </Admin>
    ),
  },
  {
    name: "Tools",
    layout: "/admin",
    path: "tools",
    icon: <MdSettings className="h-6 w-6" />,
    component: (
      <Admin>
        <Tools />
      </Admin>
    ),
  },
  {
    name: "Inbox View",
    layout: "/admin",
    path: "inbox",
    icon: <MdMail className="h-6 w-6" />,
    component: (
      <Admin>
        <ChatInterface />
      </Admin>
    ),
    //badge: 3, // Simulated unread count
  },
  {
  name: "Settings",
  layout: "/admin",
  path: "settings",
  icon: <MdSettings className="h-6 w-6" />,
  secondary: true,
  children: [
    {
      name: "User Maintenance",
      layout: "/admin",
      path: "settings/user-maintenance", // Updated path
      icon: <MdPeople className="h-5 w-5" />,
      component: (
        <Admin>
          <UserMaintenance />
        </Admin>
      ),
    },
    {
      name: "Profile & Roles",
      layout: "/admin",
      path: "settings/profile-roles", // Updated path
      icon: <MdDescription className="h-5 w-5" />,
      component: (
        <Admin>
          <GroupMaintenance/>
        </Admin>
      ),
    },
    {
      name: "Global Configs",
      layout: "/admin",
      path: "settings/global-configs", // Updated path
      icon: <MdSyncAlt className="h-5 w-5" />,
      component: (
        <Admin>
          <GlobalConfigs />
        </Admin>
      ),
    },
    {
      name: "Billing & Usage",
      layout: "/admin",
      path: "settings/billing-usage", // Updated path
      icon: <MdOutlineShoppingCart className="h-5 w-5" />,
      component: (
        <Admin>
          <BillingUsage />
        </Admin>
      ),
    },
  ],
},
  // Frontend imports
  {
    name: 'Home',
    layout: '/',
    path: 'home',
    component: <Home />,
  },
  {
    name: 'About',
    layout: '/',
    path: 'about-us',
    component: <AboutUs />,
  },
  {
    name: 'Products',
    layout: '/',
    path: 'products',
    component: <Products />,
  },
  {
    name: 'Partners',
    layout: '/',
    path: 'partners',
    component: <Partners />,
  },
  {
    name: 'Pricing',
    layout: '/',
    path: 'pricing',
    component: <Pricing />,
  },
  {
    name: 'Contacts',
    layout: '/',
    path: 'contacts',
    component: <Contacts />,
  },
  {
    name: 'Resources',
    layout: '/',
    path: 'resources',
    component: <Resources />,
  },
  {
    name: 'CompanyPage',
    layout: '/',
    path: 'companyPage',
    component: <CompanyPage />,
  },
];

export default routes;